const SPEC_CHARS = /[\\/:*?"<>|]/;

export function hasNoSpecChars(value: string): boolean {
  return !SPEC_CHARS.test(value);
}
